<template>
  <v-row>
    <!-- Dialog for managing shipment files upload -->
    <dialog-file-cabinet
      v-model="selectedShipmentId"
      :company_id="selectedCompanyId"
      :dialog="dialogFileCabinet"
      :isBooking="false"
      v-on:dialog-close="onDialogClose"
    ></dialog-file-cabinet>

    <!-- Dialog for Comment Message Box -->
    <dialog-message-box
      :dialog="dialogMessageBox"
      v-model="selectedPortShipment"
      :title="messageBoxTitle"
      :quotation_id="messageBoxQuotationId"
      :invoice_id="messageBoxInvoiceId"
      :company_id="messageBoxCompanyId"
      :company_name="messageBoxCompanyName"
      :category="messageBoxCategory"
      :tags="messageBoxTags"
      v-on:dialog-close="onDialogClose"
    ></dialog-message-box>
    <!-- 
    <dialog-manage-invoice
      :dialog="dialogManageInvoice"
      v-model="selectedInvoice"
      v-on:dialog-close="onDialogClose"
    ></dialog-manage-invoice> -->

    <dialog-shipment-information
      v-model="selectedShipmentId"
      :dialog="dialogShipmentInformation"
      :tab="shipmentInfoTab"
      v-on:dialog-close="onDialogClose"
    ></dialog-shipment-information>

    <!-- End of dialogs -->

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row>
      <v-divider></v-divider>
    </v-row>

    <v-row dense class="px-2" v-if="sortedPortShipments != null">
      <v-col>
        <v-card color="grey lighten-5" tile>
          <v-card-title
            class="
              py-2
              white
              subtitle-1
              primary--text
              font-weight-bold
              d-flex
              justify-content-center
            "
            >Shipments</v-card-title
          >

          <v-divider class="my-0"></v-divider>

          <v-card-text class="px-1">
            <v-row no-gutters>
              <v-col>
                <v-row
                  v-for="(item, id) in sortedPortShipments['0']"
                  :key="id"
                  dense
                >
                  <v-col>
                    <v-card color="white" tile>
                      <v-card-subtitle class="py-2 px-1">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="5"
                            ><span
                              class="caption font-weight-bold black--text"
                              >{{ item.shipment_order_id }}</span
                            ></v-col
                          >

                          <v-col cols="6" v-if="!item.attention_required">
                            <v-row justify="end">
                              <span
                                style="margin-top: 2px"
                                class="caption font-weight-bold black--text"
                                >{{ item.tta }} days</span
                              ><v-icon
                                size="17"
                                :color="
                                  item.tta >= 2
                                    ? 'error'
                                    : [-1, 1].includes(item.tta)
                                    ? 'amber darken-3'
                                    : 'primary'
                                "
                                class="ml-1"
                                >mdi-clock</v-icon
                              >
                            </v-row>
                          </v-col>

                          <v-col cols="6" v-else>
                            <v-row justify="end">
                              <span
                                style="margin-top: 1px"
                                class="caption font-weight-bold black--text"
                                >pending</span
                              >
                              <v-icon size="17" color="error" class="ml-1"
                                >mdi-clock-alert</v-icon
                              >
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-subtitle>

                      <v-divider class="my-0" inset></v-divider>

                      <v-card-text class="pa-1">
                        <v-row justify="space-between">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="caption black--text"
                                ><span class="font-weight-bold overline"
                                  >{{
                                    item.transaction_type == "IMPORT"
                                      ? "POL"
                                      : "POD"
                                  }}:</span
                                >
                                {{
                                  item.transaction_type == "IMPORT"
                                    ? item.origin_port.un_code
                                    : item.destination_port.un_code
                                }}</span
                              >
                            </template>
                            {{
                              item.transaction_type == "IMPORT"
                                ? item.origin_port.label
                                : item.destination_port.label
                            }}
                          </v-tooltip>

                          <span class="caption black--text"
                            ><span class="font-weight-bold overline"
                              >{{
                                item.shipment_schedule.destination_ata != null
                                  ? "ATA"
                                  : "ETA"
                              }}:</span
                            >
                            {{ getATAETA(item) || "n/a" }}</span
                          >
                        </v-row>

                        <v-row>
                          <span class="overline black--text">
                            {{ item.company.name }}</span
                          >
                        </v-row>
                      </v-card-text>

                      <v-divider class="my-0"></v-divider>

                      <v-card-actions class="pa-1">
                        <v-row justify="space-between" class="pt-2">
                          <span></span>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="primary"
                                @click="onShipmentInfoDialog(item)"
                              >
                                <v-icon size="20">mdi-tune</v-icon>
                              </v-btn>
                            </template>
                            Manage shipment information
                          </v-tooltip>

                          <v-badge
                            class="font-weight-bold"
                            :content="message_count[item.shipment_order_id]"
                            :value="message_count[item.shipment_order_id]"
                            color="amber darken-4"
                            overlap
                            bordered
                            offset-x="10"
                            offset-y="10"
                          >
                            <v-btn icon x-small @click="onViewMessages(item)">
                              <v-icon size="18" color="primary"
                                >mdi-message-text</v-icon
                              >
                            </v-btn>
                          </v-badge>

                          <v-btn
                            x-small
                            tile
                            text
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onUpdateMilestone(item, 1)"
                            :disabled="item.attention_required"
                            >Next <v-icon>mdi-chevron-right</v-icon></v-btn
                          >
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card color="grey lighten-5" tile>
          <v-card-title
            class="
              py-2
              white
              subtitle-1
              primary--text
              font-weight-bold
              d-flex
              justify-content-center
            "
            >Document Check</v-card-title
          >

          <v-divider class="my-0"></v-divider>

          <v-card-text class="px-1">
            <v-row no-gutters>
              <v-col>
                <v-row
                  v-for="(item, id) in sortedPortShipments['1']"
                  :key="id"
                  dense
                >
                  <v-col>
                    <v-card color="white" tile>
                      <v-card-subtitle class="py-2 px-1">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="5"
                            ><span
                              class="caption font-weight-bold black--text"
                              >{{ item.shipment_order_id }}</span
                            ></v-col
                          >

                          <v-col cols="6">
                            <v-row justify="end">
                              <span
                                style="margin-top: 2px"
                                class="caption font-weight-bold black--text"
                                >{{ item.tta }} days</span
                              ><v-icon
                                size="17"
                                dark
                                :color="
                                  item.tta >= 2
                                    ? 'error'
                                    : [-1, 1].includes(item.tta)
                                    ? 'amber darken-3'
                                    : 'primary'
                                "
                                class="ml-1"
                                >mdi-clock</v-icon
                              >
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <span class="overline black--text">{{
                            item.company.name
                          }}</span>
                        </v-row>
                      </v-card-subtitle>

                      <v-divider class="my-0 py-0"></v-divider>

                      <v-card-text
                        :class="`pa-2 ${
                          getDocNeededAttention(item.tasks[1].data).color
                        }`"
                      >
                        <v-row no-gutters>
                          <v-col>
                            <v-expansion-panels tile class="white">
                              <v-expansion-panel class="rounded-0">
                                <v-expansion-panel-header
                                  style="min-height: 20px; height: 30px"
                                  :class="`rounded-0 ${
                                    getDocNeededAttention(item.tasks[1].data)
                                      .color
                                  }`"
                                >
                                  <v-row justify="space-between">
                                    <span
                                      class="
                                        caption
                                        black--text
                                        font-weight-bold
                                      "
                                      >Documents</span
                                    >
                                    <span
                                      class="
                                        caption
                                        black--text
                                        font-weight-bold
                                      "
                                      >{{
                                        getDocNeededAttention(
                                          item.tasks[1].data
                                        ).count
                                      }}</span
                                    >
                                  </v-row>
                                </v-expansion-panel-header>

                                <v-divider class="my-0 py-0"></v-divider>

                                <v-expansion-panel-content
                                  color="grey lighten-5"
                                >
                                  <v-row no-gutters>
                                    <v-col>
                                      <template
                                        v-for="(doc, docId) in item.tasks[1]
                                          .data"
                                      >
                                        <v-row no-gutters :key="docId">
                                          <v-col>
                                            <v-checkbox
                                              hide-details
                                              dense
                                              class="caption"
                                              v-model="doc.status"
                                            >
                                              <template v-slot:label>
                                                <span
                                                  class="caption black--text"
                                                  >{{ doc.label }}</span
                                                >
                                              </template>
                                            </v-checkbox>
                                          </v-col>

                                          <v-col cols="2" v-show="!doc.default">
                                            <v-btn
                                              x-small
                                              icon
                                              color="error"
                                              class="mt-2 add-remove-item"
                                              @click="
                                                removeDoc(item, item.tasks, doc)
                                              "
                                              ><v-icon size="18"
                                                >mdi-minus-circle</v-icon
                                              ></v-btn
                                            >
                                          </v-col>
                                        </v-row>
                                      </template>
                                    </v-col>
                                  </v-row>

                                  <v-row class="px-2" justify="space-between">
                                    <input
                                      type="text"
                                      class="form-control rounded-0"
                                      placeholder="new doc"
                                      style="max-width: 55%"
                                      v-model="newDoc"
                                    />
                                    <v-btn
                                      x-small
                                      text
                                      color="primary"
                                      class="
                                        font-weight-bold
                                        text-button
                                        px-0
                                        pt-3
                                      "
                                      @click="addDoc(item, item.tasks[1].data)"
                                      ><v-icon size="18">add</v-icon>Add</v-btn
                                    >
                                  </v-row>

                                  <v-row class="pl-2 mt-2" justify="center">
                                    <v-btn
                                      small
                                      text
                                      tile
                                      color="primary"
                                      class="text-button font-weight-bold"
                                      @click="saveOperation(item, 1)"
                                      ><v-icon size="20" class="mr-1"
                                        >mdi-content-save</v-icon
                                      >Save</v-btn
                                    >
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-card-text>

                      <v-divider class="my-0"></v-divider>

                      <v-card-actions class="pa-1">
                        <v-row justify="space-between" class="pt-2">
                          <v-btn
                            x-small
                            tile
                            text
                            dark
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onReverseMilestone(item, 0, 1)"
                            ><v-icon>mdi-chevron-left</v-icon>Prev</v-btn
                          >

                          <shipment-files-count
                            :shipment_order_id="item.shipment_order_id"
                            :company_id="item.company.company_id"
                            v-on:open-shipment-file-dialog="
                              onOpenShipmentFileCabinet
                            "
                          ></shipment-files-count>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="primary"
                                @click="onShipmentInfoDialog(item)"
                              >
                                <v-icon size="20">mdi-tune</v-icon>
                              </v-btn>
                            </template>
                            Manage shipment information
                          </v-tooltip>

                          <v-badge
                            class="font-weight-bold"
                            :content="message_count[item.shipment_order_id]"
                            :value="message_count[item.shipment_order_id]"
                            color="amber darken-4"
                            overlap
                            bordered
                            offset-x="10"
                            offset-y="10"
                          >
                            <v-btn icon x-small @click="onViewMessages(item)">
                              <v-icon size="18" color="primary"
                                >mdi-message-text</v-icon
                              >
                            </v-btn>
                          </v-badge>

                          <v-btn
                            x-small
                            tile
                            text
                            dark
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onUpdateMilestone(item, 2)"
                            >Next <v-icon>mdi-chevron-right</v-icon></v-btn
                          >
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card color="grey lighten-5" tile>
          <v-card-title
            class="
              py-2
              white
              subtitle-1
              primary--text
              font-weight-bold
              d-flex
              justify-content-center
            "
            >Customs Submission</v-card-title
          >

          <v-divider class="my-0"></v-divider>

          <v-card-text class="px-1">
            <v-row no-gutters>
              <v-col>
                <v-row
                  v-for="(item, id) in sortedPortShipments['2']"
                  :key="id"
                  dense
                >
                  <v-col>
                    <v-card
                      :color="`${
                        item.tasks[2].data.submission_status
                          ? 'success lighten-5'
                          : 'white'
                      }`"
                      tile
                    >
                      <v-card-subtitle class="py-2 px-1">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="5"
                            ><span
                              class="caption font-weight-bold black--text"
                              >{{ item.shipment_order_id }}</span
                            ></v-col
                          >

                          <v-col cols="6">
                            <v-row justify="end">
                              <span
                                style="margin-top: 2px"
                                class="caption font-weight-bold black--text"
                                >{{ item.tta }} days</span
                              ><v-icon
                                size="17"
                                dark
                                :color="
                                  item.tta >= 2
                                    ? 'error'
                                    : [-1, 1].includes(item.tta)
                                    ? 'amber darken-3'
                                    : 'primary'
                                "
                                class="ml-1"
                                >mdi-clock</v-icon
                              >
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-subtitle>

                      <v-divider class="my-0" inset></v-divider>

                      <v-card-text class="pa-1">
                        <v-row justify="space-between">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="caption black--text"
                                ><span class="font-weight-bold overline"
                                  >{{
                                    item.transaction_type == "IMPORT"
                                      ? "POL"
                                      : "POD"
                                  }}:</span
                                >
                                {{
                                  item.transaction_type == "IMPORT"
                                    ? item.origin_port.un_code
                                    : item.destination_port.un_code
                                }}</span
                              >
                            </template>
                            {{
                              item.transaction_type == "IMPORT"
                                ? item.origin_port.label
                                : item.destination_port.label
                            }}
                          </v-tooltip>

                          <span class="caption black--text"
                            ><span class="font-weight-bold overline"
                              >{{
                                item.shipment_schedule.destination_ata != null
                                  ? "ATA"
                                  : "ETA"
                              }}:</span
                            >
                            {{ getATAETA(item) }}</span
                          >
                        </v-row>

                        <v-row>
                          <span class="overline black--text">
                            {{ item.company.name }}</span
                          >
                        </v-row>

                        <v-divider class="my-0 py-0"></v-divider>

                        <v-row>
                          <v-checkbox
                            hide-details
                            dense
                            class="caption ml-n3"
                            v-model="item.tasks[2].data.submission_status"
                            @change="saveOperation(item, 2)"
                          >
                            <template v-slot:label>
                              <span class="caption black--text">Submitted</span>
                            </template>
                          </v-checkbox>
                        </v-row>
                      </v-card-text>

                      <v-divider class="my-0 py-0"></v-divider>

                      <v-card-actions class="pa-1">
                        <v-row justify="space-between" class="pt-2">
                          <v-btn
                            x-small
                            tile
                            text
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onReverseMilestone(item, 1, 2)"
                            ><v-icon>mdi-chevron-left</v-icon>Prev</v-btn
                          >

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="primary"
                                @click="onShipmentInfoDialog(item)"
                              >
                                <v-icon size="20">mdi-tune</v-icon>
                              </v-btn>
                            </template>
                            Manage shipment information
                          </v-tooltip>

                          <v-badge
                            class="font-weight-bold"
                            :content="message_count[item.shipment_order_id]"
                            :value="message_count[item.shipment_order_id]"
                            color="amber darken-4"
                            overlap
                            bordered
                            offset-x="10"
                            offset-y="10"
                          >
                            <v-btn icon x-small @click="onViewMessages(item)">
                              <v-icon size="18" color="primary"
                                >mdi-message-text</v-icon
                              >
                            </v-btn>
                          </v-badge>

                          <v-btn
                            x-small
                            tile
                            text
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onUpdateMilestone(item, 3)"
                            >Next <v-icon>mdi-chevron-right</v-icon></v-btn
                          >
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card color="grey lighten-5" tile>
          <v-card-title
            class="
              py-2
              white
              subtitle-1
              primary--text
              font-weight-bold
              d-flex
              justify-content-center
            "
            >Taxes & Duties</v-card-title
          >

          <v-divider class="my-0"></v-divider>

          <v-card-text class="px-1">
            <v-row no-gutters>
              <v-col>
                <v-row
                  v-for="(item, id) in sortedPortShipments['3']"
                  :key="id"
                  dense
                >
                  <v-col>
                    <v-card color="white" tile>
                      <v-card-subtitle class="py-2 px-1">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="5"
                            ><span
                              class="caption font-weight-bold black--text"
                              >{{ item.shipment_order_id }}</span
                            ></v-col
                          >

                          <v-col cols="6">
                            <v-row justify="end">
                              <span
                                style="margin-top: 2px"
                                class="caption font-weight-bold black--text"
                                >{{ item.tta }} days</span
                              ><v-icon
                                size="17"
                                dark
                                :color="
                                  item.tta >= 2
                                    ? 'error'
                                    : [-1, 1].includes(item.tta)
                                    ? 'amber darken-3'
                                    : 'primary'
                                "
                                class="ml-1"
                                >mdi-clock</v-icon
                              >
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-subtitle>

                      <v-divider class="my-0" inset></v-divider>

                      <v-card-text class="pa-1">
                        <v-row class="pb-1" justify="space-between">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="caption black--text"
                                ><span class="font-weight-bold overline"
                                  >{{
                                    item.transaction_type == "IMPORT"
                                      ? "POL"
                                      : "POD"
                                  }}:</span
                                >
                                {{
                                  item.transaction_type == "IMPORT"
                                    ? item.origin_port.un_code
                                    : item.destination_port.un_code
                                }}</span
                              >
                            </template>
                            {{
                              item.transaction_type == "IMPORT"
                                ? item.origin_port.label
                                : item.destination_port.label
                            }}
                          </v-tooltip>

                          <span class="caption black--text"
                            ><span class="font-weight-bold overline"
                              >{{
                                item.shipment_schedule.destination_ata != null
                                  ? "ATA"
                                  : "ETA"
                              }}:</span
                            >
                            {{ getATAETA(item) }}</span
                          >
                        </v-row>

                        <v-row class="pb-1">
                          <span class="overline black--text">
                            {{ item.company.name }}</span
                          >
                        </v-row>

                        <v-divider class="my-0"></v-divider>

                        <v-row
                          v-if="
                            !item.issued_taxes_duties_invoice &&
                            item.tasks[3].data.has_tax_duty_charge &&
                            item.is_taxes_duties_required
                          "
                          justify="start"
                        >
                          <v-chip
                            x-small
                            class="custom-overline font-weight-bold my-1"
                            color="error"
                            label
                            text-color="white"
                          >
                            <v-icon left size="15"> mdi-alert-circle </v-icon>
                            Tax & duty invoice not issued
                          </v-chip>
                        </v-row>

                        <!-- <v-row v-else justify="start" class="mt-1">
                          <template v-for="inv in item.taxes_duties_invoices">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-chip
                                  v-on="on"
                                  :key="inv"
                                  x-small
                                  color="secondary"
                                  outlined
                                  label
                                  ripple
                                  class="px-1 mr-1 mb-1 font-weight-bold overline"
                                  @click="onManageInvoice(inv)"
                                  >{{ inv }}</v-chip
                                >
                              </template>
                              Click to open invoice
                            </v-tooltip>
                          </template>
                        </v-row> -->

                        <v-row no-gutters :class="`pa-0 ${taxDutyCheck(item)}`">
                          <v-col>
                            <v-expansion-panels tile class="white">
                              <v-expansion-panel class="rounded-0">
                                <v-expansion-panel-header
                                  style="min-height: 20px; height: 30px"
                                  :class="`caption black--text font-weight-bold rounded-0 ${taxDutyCheck(
                                    item
                                  )}`"
                                >
                                  Tax & Duty Charges
                                </v-expansion-panel-header>

                                <v-divider class="my-0 py-0"></v-divider>

                                <v-expansion-panel-content color="white">
                                  <v-row dense>
                                    <v-col>
                                      <v-row class="my-2">
                                        <span class="caption">HS Code(s):</span>
                                        <textarea
                                          class="form-control rounded-0 caption"
                                          rows="3"
                                          v-model="item.hs_code"
                                        ></textarea>
                                      </v-row>

                                      <v-row class="my-2">
                                        <span class="caption">Commodity:</span>
                                        <textarea
                                          class="form-control rounded-0 caption"
                                          rows="3"
                                          v-model="item.commodity"
                                        ></textarea>
                                      </v-row>

                                      <v-row class="px-1">
                                        <span class="caption"
                                          >Tax & Duty Currency:</span
                                        >
                                        <v-select
                                          :items="currencies"
                                          solo
                                          flat
                                          class="form-control rounded-0"
                                          v-model="item.tax_duty_currency"
                                        ></v-select>
                                      </v-row>

                                      <v-row class="my-2" dense>
                                        <v-col>
                                          <span class="caption">Tax:</span>
                                          <input
                                            class="
                                              form-control
                                              rounded-0
                                              caption
                                            "
                                            v-model="item.tax_charge"
                                          />
                                        </v-col>

                                        <v-col>
                                          <span class="caption">Duty:</span>
                                          <input
                                            class="
                                              form-control
                                              rounded-0
                                              caption
                                            "
                                            v-model="item.duty_charge"
                                          />
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>

                                  <v-row class="px-2" no-gutters>
                                    <v-col cols="2">
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            v-on="on"
                                            x-small
                                            icon
                                            tile
                                            color="primary"
                                            class="px-0"
                                            @click="onSaveTaxDutyInfo(item)"
                                            ><v-icon size="25"
                                              >mdi-content-save</v-icon
                                            ></v-btn
                                          >
                                        </template>
                                        Save
                                      </v-tooltip>
                                    </v-col>

                                    <v-col>
                                      <v-row justify="end">
                                        <!-- <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <v-btn
                                              v-on="on"
                                              v-show="
                                                item.tasks[3].data.has_tax_duty_charge
                                              "
                                              x-small
                                              tile
                                              icon
                                              color="primary"
                                              class="px-0 mx-2"
                                              @click="onIssueTaxDutyInvoice(item)"
                                              ><v-icon size="25"
                                                >mdi-receipt</v-icon
                                              ></v-btn
                                            >
                                          </template>
                                          Issue tax & duty invoice
                                        </v-tooltip> -->

                                        <shipment-files-count
                                          :shipment_order_id="
                                            item.shipment_order_id
                                          "
                                          :company_id="item.company.company_id"
                                          v-on:open-shipment-file-dialog="
                                            onOpenShipmentFileCabinet
                                          "
                                        ></shipment-files-count>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content> </v-expansion-panel
                            ></v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-card-text>

                      <v-divider class="my-0"></v-divider>

                      <v-card-actions class="pa-1">
                        <v-row justify="space-between" class="pt-2">
                          <v-btn
                            x-small
                            tile
                            text
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onReverseMilestone(item, 2, 3)"
                            ><v-icon>mdi-chevron-left</v-icon>Prev</v-btn
                          >

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="primary"
                                @click="onShipmentInfoDialog(item)"
                              >
                                <v-icon size="20">mdi-tune</v-icon>
                              </v-btn>
                            </template>
                            Manage shipment information
                          </v-tooltip>

                          <v-badge
                            class="font-weight-bold"
                            :content="message_count[item.shipment_order_id]"
                            :value="message_count[item.shipment_order_id]"
                            color="amber darken-4"
                            overlap
                            bordered
                            offset-x="10"
                            offset-y="10"
                          >
                            <v-btn icon x-small @click="onViewMessages(item)">
                              <v-icon size="18" color="primary"
                                >mdi-message-text</v-icon
                              >
                            </v-btn>
                          </v-badge>

                          <v-btn
                            x-small
                            tile
                            text
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onUpdateMilestone(item, 4)"
                            >Next <v-icon>mdi-chevron-right</v-icon></v-btn
                          >
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card color="grey lighten-5" tile>
          <v-card-title
            class="
              py-2
              white
              subtitle-1
              primary--text
              font-weight-bold
              d-flex
              justify-content-center
            "
            >Complete</v-card-title
          >

          <v-divider class="my-0"></v-divider>

          <v-card-text class="px-1">
            <v-row no-gutters>
              <v-col>
                <v-row
                  v-for="(item, id) in sortedPortShipments['4']"
                  :key="id"
                  dense
                >
                  <v-col>
                    <v-card
                      :color="
                        item.milestone_completed ? 'success lighten-5' : 'white'
                      "
                      tile
                    >
                      <v-card-subtitle class="py-2 px-1">
                        <v-row no-gutters justify="space-between">
                          <v-col cols="5"
                            ><span
                              class="caption font-weight-bold black--text"
                              >{{ item.shipment_order_id }}</span
                            ></v-col
                          >

                          <v-col cols="6">
                            <v-row justify="end">
                              <span
                                style="margin-top: 2px"
                                class="caption font-weight-bold black--text"
                                >{{ item.tta }} days</span
                              ><v-icon
                                size="17"
                                dark
                                :color="
                                  item.tta >= 2
                                    ? 'error'
                                    : [-1, 1].includes(item.tta)
                                    ? 'amber darken-3'
                                    : 'primary'
                                "
                                class="ml-1"
                                >mdi-clock</v-icon
                              >
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-subtitle>

                      <v-divider class="my-0" inset></v-divider>

                      <v-card-text class="pa-1">
                        <v-row justify="space-between">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" class="caption black--text"
                                ><span class="font-weight-bold overline"
                                  >{{
                                    item.transaction_type == "IMPORT"
                                      ? "POL"
                                      : "POD"
                                  }}:</span
                                >
                                {{
                                  item.transaction_type == "IMPORT"
                                    ? item.origin_port.un_code
                                    : item.destination_port.un_code
                                }}</span
                              >
                            </template>
                            {{
                              item.transaction_type == "IMPORT"
                                ? item.origin_port.label
                                : item.destination_port.label
                            }}
                          </v-tooltip>

                          <span class="caption black--text"
                            ><span class="font-weight-bold overline"
                              >{{
                                item.shipment_schedule.destination_ata != null
                                  ? "ATA"
                                  : "ETA"
                              }}:</span
                            >
                            {{ getATAETA(item) }}</span
                          >
                        </v-row>

                        <v-row>
                          <span class="overline black--text">
                            {{ item.company.name }}</span
                          >
                        </v-row>
                      </v-card-text>

                      <v-divider class="my-0"></v-divider>

                      <v-card-actions class="pa-1">
                        <v-row justify="space-between" class="pt-2">
                          <v-btn
                            x-small
                            tile
                            text
                            color="primary"
                            class="font-weight-bold text-button-xs px-0"
                            @click="onReverseMilestone(item, 3, 4)"
                            ><v-icon>mdi-chevron-left</v-icon>Prev</v-btn
                          >

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="primary"
                                @click="onShipmentInfoDialog(item)"
                              >
                                <v-icon size="20">mdi-tune</v-icon>
                              </v-btn>
                            </template>
                            Manage shipment information
                          </v-tooltip>

                          <v-badge
                            class="font-weight-bold"
                            :content="message_count[item.shipment_order_id]"
                            :value="message_count[item.shipment_order_id]"
                            color="amber darken-4"
                            overlap
                            bordered
                            offset-x="10"
                            offset-y="10"
                          >
                            <v-btn icon x-small @click="onViewMessages(item)">
                              <v-icon size="18" color="primary"
                                >mdi-message-text</v-icon
                              >
                            </v-btn>
                          </v-badge>

                          <span></span>

                          <!-- <v-btn
                            x-small
                            icon
                            color="primary"
                            class="px-0"
                            @click="onCompleteMilestone(item)"
                            ><v-icon size="25">mdi-check-bold</v-icon></v-btn
                          > -->
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../../const"
import moment from "moment"
import DialogFileCabinet from "@/components/user/DialogFileCabinet.vue"
import DialogMessageBox from "@/components/user/DialogMessageBox.vue"
import DialogManageInvoice from "@/components/admin/dialogs/DialogManageInvoice"
import DialogShipmentInformation from "@/components/user/DialogShipmentInformation"
export default {
  components: {
    DialogFileCabinet,
    DialogMessageBox,
    DialogManageInvoice,
    DialogShipmentInformation,
  },
  props: ["value", "shipments"],
  data() {
    return {
      CONSTANT: constant,
      MOMENT: moment,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,

      dialogManageInvoice: false,
      selectedInvoice: null,

      sortedPortShipments: this.value || null,

      task_levels: {
        0: "Shipments",
        1: "Document Check",
        2: "Customs Submission",
        3: "Taxes & Duties",
        4: "Completed",
      },

      newDoc: null,
      docsNeeded: [
        {
          status: false,
          label: "Commercial invoice",
          default: true,
        },
        {
          status: false,
          label: "Packing list",
          default: true,
        },
        {
          status: false,
          label: "BL / AWB",
          default: true,
        },
        {
          status: false,
          label: "NOA",
          default: true,
        },
      ],

      custom_submission_status: {
        submission_status: false,
      },

      currencies: [],

      shipmentInfoTab: null,

      dialogFileCabinet: false,
      dialogShipmentInformation: false,

      dialogMessageBox: false,
      messageBoxTitle: null,
      messageBoxQuotationId: null,
      messageBoxInvoiceId: null,
      messageBoxCompanyId: null,
      messageBoxCompanyName: null,
      messageBoxCategory: "shipment",
      messageBoxTags: [],

      message_count: {},

      selectedPortShipment: null,
      selectedShipmentId: null,
      selectedCompanyId: null,
    }
  },
  created() {
    this.loadCurrenciesList()
  },
  mounted() {},
  watch: {
    value() {
      this.sortedPortShipments = this.value
      // initialise the message count object
      this.shipments.forEach((element) => {
        this.$set(this.message_count, element.shipment_order_id, 0)
      })

      // set the comment messages for each quotation
      const firestore_db = this.$root.messageCenterApp.firestore()
      this.shipments.forEach((element) => {
        this.setMessageCount(firestore_db, element)
      })
    },
  },

  methods: {
    /**
     * Get currencies list
     */
    async loadCurrenciesList() {
      var resp = await this.$https.get("/api/currencies/list/dropdown")
      this.currencies = resp.data.data || []
    },

    /** Add doc needed */
    addDoc(port_shipment, data) {
      if (this.newDoc != null) {
        let nd = this.newDoc
        data.push({
          status: false,
          label: nd,
          default: false,
        })

        this.newDoc = null
      }
    },

    /** remove selected doc */
    removeDoc(port_shipment, docs, doc) {
      docs[1].data = docs[1].data.filter((item) => {
        return item != doc
      })
    },

    /** Get & Parse the ATA or ETA */
    getATAETA(item) {
      if (item.shipment_schedule.destination_ata) {
        return moment(item.shipment_schedule.destination_ata).format("MMM DD")
      } else if (item.shipment_schedule.destination_eta) {
        return moment(item.shipment_schedule.destination_eta).format("MMM DD")
      } else {
        return null
      }
    },

    /**
     * get document needed attention
     */
    getDocNeededAttention(docs) {
      let count = docs.length
      let color = "white"

      docs.forEach((element) => {
        if (!element.status) {
          count -= 1
        }
      })

      if (count == docs.length) {
        color = "success lighten-5"
      } else if (count == 0) {
        color = "white"
      } else {
        color = "amber darken-1"
      }

      return { count: `${count} / ${docs.length}`, color: color }
    },

    /**
     * tax & duties placeholder completed
     */
    taxDutyCheck(item) {
      if (item.tasks[3].data.has_tax_duty_charge) {
        return "success lighten-5"
      } else {
        return "amber darken-1"
      }
    },

    /**
     * Save operation
     */
    saveOperation(port_shipment, task_level) {
      // compose the postform data
      let postform = {
        task_level: task_level,
        tasks: port_shipment.tasks,
        milestone_completed: false,
      }

      // emit the update milestone method
      this.$emit("update-milestone", port_shipment, postform)
    },

    /**
     * Emit update milestone
     */
    onUpdateMilestone(port_shipment, task_level) {
      let tasks = port_shipment.tasks
      let milestone_completed = task_level == 4 ? true : false

      // new task to be assigned
      let task = {
        level: task_level,
        name: this.task_levels[task_level],
        data: null,
      }

      // switch statement
      // assign the data for the given level
      switch (task_level) {
        // Shipment (starting)
        case 0:
          task.data = null
          break

        // Documents Needed
        case 1:
          task.data = JSON.parse(JSON.stringify(this.docsNeeded))
          // if container is AIR
          if (port_shipment.container_load == constant.QUOTATION_TYPE_AIR) {
            // remove NOA for air
            task.data.pop()
          }
          break

        // Customs submission
        case 2:
          task.data = JSON.parse(JSON.stringify(this.custom_submission_status))
          break

        // Taxes & duties
        case 3:
          task.data = JSON.parse(JSON.stringify({ has_tax_duty_charge: false }))
          break

        // milestone completed
        case 4:
          task.data = null
          milestone_completed = true
          break

        default:
          break
      }

      // append the new task into tasks array
      tasks.push(task)

      // compose the postform data
      let postform = {
        task_level: task_level,
        tasks: tasks,
        milestone_completed: milestone_completed,
      }

      // emit the update milestone method
      this.$emit("update-milestone", port_shipment, postform)
    },

    /**
     * Emit update milestone
     */
    onReverseMilestone(port_shipment, new_task_level, current_task_level) {
      let tasks = port_shipment.tasks
      let milestone_completed = false

      tasks.splice(current_task_level, 1)

      // compose the postform data
      let postform = {
        task_level: new_task_level,
        tasks: tasks,
        milestone_completed: milestone_completed,
      }

      // emit the update milestone method
      this.$emit("update-milestone", port_shipment, postform)
    },

    /**
     * On complete milestone
     */
    onCompleteMilestone(port_shipment) {
      let tasks = port_shipment.tasks

      // compose the postform data
      let postform = {
        task_level: 4,
        tasks: tasks,
        milestone_completed: true,
      }

      // emit the update milestone method
      this.$emit("update-milestone", port_shipment, postform)
    },

    /**
     * On Save Tax & Duty Information
     */
    async onSaveTaxDutyInfo(port_shipment) {
      this.$root.blockUImsg = "Saving..."
      this.$root.blockUIshow = true

      // if currency is not selected
      if (
        (port_shipment.tax_charge > 0 || port_shipment.duty_charge > 0) &&
        port_shipment.tax_duty_currency == null
      ) {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = "Please select tax & duty currency"

        this.$root.blockUIshow = false
        return
      }

      let postform = {
        hs_code: port_shipment.hs_code,
        commodity: port_shipment.commodity,
        tax_duty_currency: port_shipment.tax_duty_currency,
        tax_charge: port_shipment.tax_charge,
        duty_charge: port_shipment.duty_charge,
      }

      let resp = await this.$https.put(
        `/api/port_shipment_tasks/${port_shipment.port_shipment_milestone_id}/tax_duty`,
        postform
      )

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        port_shipment.tasks[3].data.has_tax_duty_charge = true

        // if both tax & duty value is not zero
        if (port_shipment.tax_charge == 0 && port_shipment.duty_charge == 0) {
          port_shipment.is_taxes_duties_required = false
        } else {
          port_shipment.is_taxes_duties_required = true
        }

        // save operation
        this.saveOperation(port_shipment, 3)

        // this.showSnackbar = true;
        // this.snackbarColor = "success";
        // this.snackbarMsg = "Successfully saved!";
      } else {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }

      this.$root.blockUIshow = false
    },

    /**
     * on open shipment file cabinet
     */
    onOpenShipmentFileCabinet(shipment_order_id, company_id) {
      this.selectedShipmentId = shipment_order_id
      this.selectedCompanyId = company_id
      this.dialogFileCabinet = true
    },

    /**
     * On open shipment information dialog
     */
    onShipmentInfoDialog(port_shipment) {
      this.selectedShipmentId = port_shipment.shipment_order_id
      this.shipmentInfoTab = 1
      this.dialogShipmentInformation = true
    },

    /**
     * on manage invoice
     */
    async onManageInvoice(invoice_id) {
      // // only admin can open this dialog
      // if (this.$root.is_admin) {
      //   this.$root.blockUImsg = "Loading invoice information";
      //   this.$root.blockUIshow = true;
      //   let resp = await this.$https.get(`/api/invoices/${invoice_id}`);
      //   if (resp.data.status == constant.RESPONSE_STATUS_OK) {
      //     this.selectedInvoice = resp.data.data;
      //     this.dialogManageInvoice = true;
      //   } else {
      //     console.log("OnManageInvoice Error: ", resp.data);
      //     this.showSnackbar = true;
      //     this.snackbarColor = "error";
      //     this.snackbarMsg = resp.data.msg;
      //   }
      //   this.$root.blockUIshow = false;
      // }
    },

    /**
     * On issue tax & duty invoice
     */
    onIssueTaxDutyInvoice(port_shipment) {
      // let routeData = this.$router.resolve({
      //   name: "newinvoice",
      //   params: { id: port_shipment.shipment_order_id },
      // });
      // window.open(
      //   `${routeData.href}?id=${port_shipment.shipment_order_id}&tax=${port_shipment.tax_charge}&duty=${port_shipment.duty_charge}&currency=${port_shipment.tax_duty_currency}&source=port-shipment-task`,
      //   "_blank"
      // );
    },

    /**
     * Set the comment message count for each shipment
     */
    setMessageCount(firestore_db, shipment) {
      // Get the message count and listen to the document
      firestore_db
        .collection("comments")
        .doc(shipment.shipment_order_id)
        .onSnapshot((doc) => {
          if (!doc.exists) {
            this.message_count[shipment.shipment_order_id] = 0
            // console.error("doc doesnt exist");
          } else {
            // get the message count number
            this.message_count[shipment.shipment_order_id] = doc.data().count
          }
        })
    },

    /**
     * On open the message box
     */
    onViewMessages(shipment) {
      this.messageBoxTitle = `Shipment ${shipment.shipment_order_id}`
      this.messageBoxQuotationId = shipment.shipment_order_id
      this.messageBoxInvoiceId = null
      this.messageBoxCompanyId = shipment.company.company_id
      this.messageBoxCompanyName = shipment.company.name
      this.messageBoxTags = [
        `${shipment.container_load.toLowerCase()}`,
        `${shipment.transaction_type.toLowerCase()}`,
        `${shipment.incoterm.incoterm.toLowerCase()}`,
        `${shipment.cargo_type.code.toLowerCase()}`,
      ]
      this.dialogMessageBox = true
    },

    /**
     * on clode dialog
     */
    onDialogClose(dialog, object, hasChange) {
      switch (dialog) {
        case constant.DIALOG_FILE_CABINET:
          this.dialogFileCabinet = false
          break

        case constant.DIALOG_MESSAGE_BOX:
          this.dialogMessageBox = false
          this.messageBoxTitle = null
          this.messageBoxQuotationId = null
          this.messageBoxInvoiceId = null
          this.messageBoxCompanyId = null
          this.messageBoxCompanyName = null
          this.messageBoxTags = null
          break

        case constant.DIALOG_MANAGE_INVOICE:
          this.dialogManageInvoice = false
          this.selectedInvoice = null
          break

        case constant.DIALOG_SHIPMENT_INFORMARTION:
          this.dialogShipmentInformation = false
          this.shipmentInfoTab = null
          break

        default:
          break
      }

      this.selectedPortShipment = null
      this.selectedShipmentId = null
      this.selectedCompanyId = null
    },
  },
  computed: {},
}
</script>

<style scoped>
::v-deep .v-expansion-panel-content__wrap {
  /* padding: 0 0px 10px; */
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
}

.v-btn--icon.v-size--x-small.add-remove-item {
  height: 16px;
  width: 16px;
}

.v-application .custom-overline {
  font-size: 0.625rem !important;
  font-weight: 400;
  letter-spacing: 0.09375rem !important;
  line-height: normal;
  /* text-transform: uppercase; */
  font-family: Roboto, sans-serif !important;
}
</style>
